const defaultSort = 'created';
const initialState = {
  activePage: 1,
  totalPages: false,
  leadBook: [],
  leadPage: [],
  agencyFilter: '',
  pageSize: 15,
  loading: false,
  records: [],
  searchTerm: '',
  selectedLeads: [],
  sortTerm: defaultSort,
  sortInverse: 'desc',
  totalLeads: 50,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LEADS_KEYS':
      return {
        ...state,
        ...action.payload,
      };
    case 'LOAD_LEADS_LIST': {
      const leadBook = [];
      const activePage = action.payload.page;
      leadBook[activePage - 1] = action.payload.shopperList || [];

      return {
        ...state,
        leadBook,
        leadPage: leadBook[activePage - 1],
        totalLeads: action.payload.totalShoppers,
        pageSize: action.payload.pageSize,
        totalPages: action.payload.totalPages,
        activePage,
      };
    }
    case 'ADD_SELECTED_LEAD':
      return {
        ...state,
        selectedLeads: [
          ...state.selectedLeads,
          action.lead,
        ],
      };
    case 'REMOVE_SELECTED_LEAD':
      return {
        ...state,
        selectedLeads: state.selectedLeads.filter(l => (l.username !== action.username)),
      };
    case 'CLEAR_LEADS_REDUCER':
      return { ...initialState };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
